import { useContext } from 'react';
import { VersionContext, type IVersionContext } from './VersionProvider';

export const useVersion = (): IVersionContext => {
  const context = useContext(VersionContext);

  if (!context) {
    throw new Error('useVersion must be used within VersionProvider');
  }

  return context;
};
